import { render, staticRenderFns } from "./faqDetails.vue?vue&type=template&id=6acaaefc"
import script from "./faqDetails.vue?vue&type=script&lang=js"
export * from "./faqDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports